import { render } from "./BottomNavigation.vue?vue&type=template&id=70e56778"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/BottomNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70e56778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70e56778', __exports__)) {
    api.reload('70e56778', __exports__)
  }
  
  module.hot.accept("./BottomNavigation.vue?vue&type=template&id=70e56778", () => {
    api.rerender('70e56778', render)
  })

}


export default __exports__